import { useLocale } from '~/shared/libs/gatsby-plugin-i18n';
import { graphql, useStaticQuery } from 'gatsby';

import { useFrontmatter } from '~/shared/contexts/frontmatter';
import type { KeyVisualQuery } from '~/generated/types/gatsby';

import GameKeyVisual from './games';
import OvenbreakKeyVisual from './ovenbreak';
import OvensmashKeyVisual from './ovensmash';

function KeyVisual() {
  const locale = useLocale();
  const frontmatter = useFrontmatter();
  const data = useStaticQuery<KeyVisualQuery>(graphql`
    query KeyVisualVariants {
      allStrapiGamesiteMain {
        nodes {
          game
          locale
          environment
        }
      }
    }
  `);

  const gameNode = data.allStrapiGamesiteMain.nodes
    ?.filter(
      (node) => node.environment === (process.env.GATSBY_ENVIRONMENT ?? 'preview') && node.game === frontmatter.gameId,
    )
    .find((node) => node.locale.toLowerCase() === locale.toLowerCase());

  if (gameNode?.game === 'cookierun') {
    return <OvenbreakKeyVisual />;
  }

  if (gameNode?.game === 'ovensmash') {
    return <OvensmashKeyVisual />;
  }

  return <GameKeyVisual />;
}

export default KeyVisual;
